import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function HeroCarousel({ slides }) {
    const [indiceAtual, setIndiceAtual] = useState(0);

    const navigate = useNavigate();

    const total = slides.length;

    function proximo() {
        setIndiceAtual(function (valorAnterior) {
            if (valorAnterior === total - 1) {
                return 0;
            }
            return valorAnterior + 1;
        });
    }

    function anterior() {
        setIndiceAtual(function (valorAnterior) {
            if (valorAnterior === 0) {
                return total - 1;
            }
            return valorAnterior - 1;
        });
    }

    function irParaProjeto(id) {
        navigate("/projeto/" + id);
    }

    if (!slides || slides.length === 0) {
        return null;
    }

    const slideAtual = slides[indiceAtual];

    return (
        <div className="hero">

            <img
                src={slideAtual.imagem}
                alt="Destaque"
                className="hero-imagem"
                onClick={function () {
                    console.log("clicou", slideAtual.projetoId);
                    irParaProjeto(slideAtual.projetoId);
                }}
                style={{ cursor: "pointer" }}
            />

            <div className="hero-overlay">
                <div className="hero-texto">
                    <span className="linha pequena">PORTFÓLIO</span>
                    <span className="linha media">TECNO</span>
                    <span className="linha gigante">LOG</span>
                    <span className="linha gigante">IAS</span>
                    <span className="linha pequena">EDUCACIONAIS</span>
                </div>
            </div>

            {total > 1 && (
                <>
                    {total > 1 && (
                        <>
                            <button
                                className="carousel-btn hero-btn left"
                                onClick={anterior}

                            >
                                ‹
                            </button>

                            <button
                                className="carousel-btn hero-btn right"
                                onClick={proximo}

                            >
                                ›
                            </button>
                        </>
                    )}
                </>
            )}

            <div className="hero-indicadores">

                {slides.map(function (slide, indice) {

                    const ativo = indice === indiceAtual;
                    const ultimo = indice === slides.length - 1;

                    return (
                        <span key={indice}>

                            <span
                                className={`hero-indicador ${ativo ? "ativo" : ""}`}
                                onClick={function () {
                                    setIndiceAtual(indice);
                                }}
                            >
                                {slide.titulo}
                            </span>

                            {!ultimo && <span className="hero-separador"> | </span>}

                        </span>
                    );

                })}

            </div>
        </div>
    );
}

export default HeroCarousel;